<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="indexTitle"
        :switch-text="switchText"
        @switchTo="toRegister"
        :has-back="!isIndex && !fromGuest"
        @back="back"
        :businessType="businessType"
      >
        <template #form>
          <div
            class="login-tab"
            ref="loginTabRef"
            v-if="isIndex && hasMoreSignInMethod"
          >
            <span
              v-for="item in signInMethodLists"
              :key="item.id"
              :class="{ active: tabType === item.name }"
              @click="valueChange(item.name)"
              >{{ $t(`login.loginPage.${item.name}`) }}</span
            >
            <i class="login-type-dot"></i>
          </div>
          <component ref="form" :is="component" />
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>
<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import EmailStepAccount from './components/EmailStepAccount.vue'
import EmailStepDetail from './components/EmailStepDetail.vue'
import BaseMixin from '@/mixins/BaseMixin'
import { mapGetters } from 'vuex'
import anime from 'animejs/lib/anime.es.js'
import { getBusinessType } from '@/constant'
export default {
  components: {
    LoginLayout,
    LoginContainer,
    EmailStepAccount,
    EmailStepDetail,
  },
  mixins: [BaseMixin],
  props: {},
  data() {
    return {
      input: '',
      tabType: '',
    }
  },
  computed: {
    ...mapGetters(['eventData']),
    component() {
      const _type = 'email'
      const _step = this.step
      if (_type === 'email') {
        return _step === 'account' ? 'EmailStepAccount' : 'EmailStepDetail'
      }
      return 'EmailStepAccount'
    },
    hasMoreSignInMethod() {
      // 登录方式为一种 则不显示dot
      return getBusinessType().signInMethods.length > 1
    },
    switchText() {
      return this.isMobile
        ? this.$t('login.loginPage.newSignup')
        : this.$t('login.loginPage.SignUp')
    },
    signInMethodLists() {
      let methods = []
      const currentSignInMethod = getBusinessType().signInMethods
      currentSignInMethod.map((connector, index) => {
        methods.push({
          id: index,
          name: connector,
        })
      })
      return methods
    },
    indexTitle() {
      // 如果有一万个南京银行要求不同的标题
      return this.$t(`login.loginPage.${getBusinessType().sloganFromLocal}`)
    },
    businessType() {
      return getBusinessType().id
    },
  },
  watch: {
    $route(newVal) {
      newVal.params.type && this.valueChange(newVal.params.type)
    },
  },
  async created() {
    // 获取用户地域
    // const { type } = await getUserRegional()
    // // 国外用户邮箱注册
    // this.tabType = type || this.$route.params.type || 'phone'
    // // 嘉宾页不可跳转 且 当当前页面已经位于对应步骤 不需要跳转
    // if (!this.fromGuest && this.tabType !== this.$route.params.type) {
    //   this.$router.push({
    //     params: { ...this.$route.params, type: this.tabType },
    //     query: { ...this.$route.query },
    //   })
    // }
  },
  mounted() {
    this.$nextTick(function () {
      this.isIndex && this.animeTab(0)
    })
  },
  methods: {
    animeTab(duration = 400) {
      const loginTabRef = this.$refs.loginTabRef
      const currentTab = ['phone', 'email']
      const currentIndex = currentTab.indexOf(this.tabType)
      const wrapWidth = loginTabRef && loginTabRef.getBoundingClientRect().width
      const ev = wrapWidth / currentTab.length
      const offset = wrapWidth / currentTab.length / 2
      const offsetMove = ev * (currentIndex < 0 ? 0 : currentIndex) + offset
      anime({
        targets: '.login-type-dot',
        translateX: offsetMove - 3,
        easing: 'easeInCubic',
        duration: duration,
      })
    },
    valueChange(val) {
      this.tabType = val
      this.animeTab()
      this.$router.push({
        params: { ...this.$route.params, type: val },
        query: { ...this.$route.query },
      })
    },
    back() {
      this.$refs['form'].back()
    },
    toRegister() {
      // 注册
      const toType = this.hasBanner ? '/detail' : '/account'
      this.$router
        .replace({
          path: '/cim/register/email' + toType,
          query: { ...this.$route.query },
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.login-tab {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 7px 0 8px;
  margin-bottom: 24px;

  & > span {
    color: #6e7191;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: block;
    cursor: pointer;
  }

  .active {
    color: #14142a;
    position: relative;
  }

  .login-type-dot {
    width: 8px;
    height: 8px;
    background: #14142b;
    display: inline-block;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 100%;
    transform: translateX(77px);
  }
}
</style>
